import { createContext, ReactNode, RefObject } from "react";

interface RefContextType {
  layoutRef: RefObject<HTMLDivElement> | null;
}

interface RefProviderType {
  children: ReactNode;
  layoutRef: RefObject<HTMLDivElement>;
}

export const RefContext = createContext<RefContextType>({
  layoutRef: null,
});

export const RefProvider = ({ children, layoutRef }: RefProviderType) => {
  return (
    <RefContext.Provider value={{ layoutRef }}>{children}</RefContext.Provider>
  );
};
